import type { PropsWithChildren } from "react";
import { Typography } from "@mui/material";
import { type FactoringStatusType, statusColorMap, statusToJapanese } from "../common3/factoringStatus";

interface FactoringStatusProps {
  status: FactoringStatusType;
}

// Component to display status with appropriate color
export function FactoringStatus({
  status,
  children,
}: PropsWithChildren<FactoringStatusProps>) {
  return (
    <Typography
      component="span"
      sx={{
        color: statusColorMap[status],
        fontWeight: "medium",
      }}
    >
      {children || statusToJapanese[status]}
    </Typography>
  );
}
